export enum OrgType {
    Personal = 1,
    Business = 2
}
